import http_request from './http_request'
import config from 'config'

function getNotificationPreferencesData() {
	return http_request.get(`${config.api}notifications`)
		.send()
}

function updateEmailNotification(email) {
	return http_request.put(`${config.api}notifications`)
		.send({
			email,
		})
}

export default {
	getNotificationPreferencesData,
	updateEmailNotification,
}
